import { render, staticRenderFns } from "./detail-arrow-down.vue?vue&type=template&id=265c190e&scoped=true&"
import script from "./detail-arrow-down.vue?vue&type=script&lang=js&"
export * from "./detail-arrow-down.vue?vue&type=script&lang=js&"
import style0 from "./detail-arrow-down.vue?vue&type=style&index=0&id=265c190e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265c190e",
  null
  
)

export default component.exports